export default __webpack_public_path__ + "static/media/pro-r-img.b33fbda5.png";